exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bookmarks-wrapper[data-v-5c2af31a]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:.05em;padding:.2em;-webkit-box-shadow:0 1px 1px hsla(0,0%,4%,.2);box-shadow:0 1px 1px hsla(0,0%,4%,.2)}.bookmarks-wrapper .bookmarks[data-v-5c2af31a]{position:relative;overflow-x:auto;overflow-y:hidden;-ms-overflow-style:none;overflow:-moz-scrollbars-none}.bookmarks-wrapper .bookmarks[data-v-5c2af31a]::-webkit-scrollbar{display:none}.bookmarks-wrapper a.tag[data-v-5c2af31a]:hover{text-decoration:none}.bookmarks-wrapper .tag.check[data-v-5c2af31a]{margin-left:.1em}.bookmarks-wrapper .field.is-grouped .control[data-v-5c2af31a]:not(:last-child){margin-right:.25em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c2af31a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/Bookmarks.vue
// module id = Bb+X
// module chunks = 66